import { GenplanLayer } from "../../map/genplanLayer"
import { sum } from "../../omnia"

import m = omnia.models

export function calcFieldTotal(layer: GenplanLayer, units: m.GenericPlanUnitId) {

    const areaFactor = getAreaFactor(units)
    const areaRounding = areaFactor == 1 ? 1 : 100

    const zones = layer.zones
        .map(z => ({
            area: Math.round((z.currentFeatureArea / areaFactor) * areaRounding) / areaRounding,
            rate: Number(z.value) || 0
        }))
        .map(z => ({
            ...z,
            qty: z.area * z.rate
        }))

    const rounding = getQtyRoundingFactor(units)

    const total = Math.round(sum(zones, z => z.qty) * rounding) / rounding

    return total

}

function getQtyRoundingFactor(units: m.GenericPlanUnitId) {
    return 10
}

function getAreaFactor(units: m.GenericPlanUnitId) {

    switch (units) {

        case m.GenericPlanUnitId.seeds_m2:
            return 1

        default:
            return 10000

    }
}
